import { render, staticRenderFns } from "./cashpay.vue?vue&type=template&id=3fdbf5fd"
import script from "./cashpay.vue?vue&type=script&lang=js"
export * from "./cashpay.vue?vue&type=script&lang=js"
import style0 from "./cashpay.vue?vue&type=style&index=0&id=3fdbf5fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports